import { Button } from 'baseui/button';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { addDays } from 'date-fns';
import { useState } from 'react';
import { StateVariable } from '../../../../utils/stateVariable';
import { FlexDate, FlexDateRange } from '../types';
import AddEventForm from './AddEventForm';
import { useIntl, FormattedMessage } from 'react-intl';

export interface IAddEventState {
    date: FlexDate | undefined,
    dateRange: FlexDateRange | undefined,
}


export interface IAddEventDialog {
    isOpen: boolean,
    setIsOpen: any,
    onAdd: any,
}

export const AddEventDialog = (props: IAddEventDialog) => {

    const [state, setState] = useState<IAddEventState>({
        date: { date: new Date(), evenMonths: false, flexDay: false, flexMonth: false, flexYear: false, oddMonths: false },
        dateRange: {
            start: { date: addDays(new Date(), -1), evenMonths: false, flexDay: false, flexMonth: false, flexYear: false, oddMonths: false },
            end: { date: new Date(), evenMonths: false, flexDay: false, flexMonth: false, flexYear: false, oddMonths: false }
        }
    });

    const myState : StateVariable<IAddEventState> = {  value: state, setValue: setState };

    return (
        <>
            <Modal size='auto' closeable onClose={() => props.setIsOpen(false)} isOpen={props.isOpen}>
                <ModalHeader><FormattedMessage id="Calendar.AddEvent" defaultMessage="Add a new Event" /></ModalHeader>
                <ModalBody>
                    <AddEventForm value={myState}></AddEventForm>
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={() => { props.setIsOpen(false); }}>
                    <FormattedMessage id="cancel" defaultMessage="Cancel" />
                    </ModalButton>
                    <ModalButton onClick={() => { props.onAdd(state); props.setIsOpen(false) }}><FormattedMessage id="add" defaultMessage="Add" /></ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}




